module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/WWF-e97081037448a4847c548b09ec3a7b8b.png";